import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/pics/2.svg'


const _hoisted_1 = { class: "min-h-screen bg-black text-white flex flex-col items-center justify-center px-4 py-16" }
const _hoisted_2 = { class: "w-full max-w-md" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "text-red-500 text-sm text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "text-green-500 text-sm text-center"
}
const _hoisted_6 = ["disabled"]

import { ref } from 'vue'
import axios from 'axios'
import SuccessModal from '@/components/SuccessModal.vue'
import MarketSignal from '@/components/MarketSignal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const markets = ref([
  { id: 'US', name: '美国' },
  { id: 'HK', name: '香港' },
  { id: 'CN', name: '中国' },
  { id: 'EU', name: '欧洲' },
  { id: 'JP', name: '日本' }
])

const email = ref('')
const isLoading = ref(false)
const errorMsg = ref('')
const successMsg = ref('')
const showSuccessModal = ref(false)

const handleSubmit = async () => {
  if (!email.value) return

  isLoading.value = true
  errorMsg.value = ''
  successMsg.value = ''

  try {
    const response = await axios.post('/api/register', { email: email.value.trim() })

    if (response.status === 200) {
      showSuccessModal.value = true
      email.value = ''
    } else if (response.status === 201) {
      successMsg.value = '这个电邮已经订阅过了，感谢你的支持！'
    }
  } catch (error) {
    errorMsg.value = '订阅失败，请稍后再试'
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("main", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-40 h-40 mb-16" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "3% Logo",
          class: "w-full h-full object-contain glow-effect"
        })
      ], -1)),
      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-3xl md:text-5xl font-bold text-center mb-8" }, [
        _createTextVNode(" 只有少数人的智慧"),
        _createElementVNode("br"),
        _createTextVNode("才能让你稳步致胜"),
        _createElementVNode("br"),
        _createTextVNode("实现财富持续增值！ ")
      ], -1)),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm md:text-lg text-gray-300 text-center mb-8 max-w-lg" }, " 財富的流動遵循著隱秘的法則。大多數人終其一生被蒙在鼓裡，隨波逐流。 ", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleSubmit, ["prevent"]),
          class: "space-y-4"
        }, [
          _createElementVNode("div", null, [
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: "email",
              class: "block text-sm font-medium mb-2"
            }, "填写电邮地址 *", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              required: "",
              disabled: isLoading.value,
              class: "w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-transparent"
            }, null, 8, _hoisted_3), [
              [_vModelText, email.value]
            ])
          ]),
          (errorMsg.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMsg.value), 1))
            : _createCommentVNode("", true),
          (successMsg.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(successMsg.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            disabled: isLoading.value,
            class: "w-full bg-yellow-500 text-black font-bold py-2 px-4 rounded-lg hover:bg-yellow-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          }, _toDisplayString(isLoading.value ? '处理中...' : '立即订阅'), 9, _hoisted_6)
        ], 32),
        _cache[3] || (_cache[3] = _createStaticVNode("<p class=\"text-xs text-gray-400 mt-4 text-center\" data-v-f9b7f864> P.S: 请把&quot;newsletter@3pct.top&quot;新增入电邮的白名单，防止无法准时收到电子报 </p><div class=\"text-center mb-16 mt-16\" data-v-f9b7f864><p class=\"text-sm tracking-[1.5em] uppercase mb-4\" data-v-f9b7f864>电子报</p><h2 class=\"text-5xl md:text-7xl font-bold mb-6\" data-v-f9b7f864>财富进化论</h2><p class=\"text-xl md:text-xl max-w-2xl mx-auto\" data-v-f9b7f864> 为你精选市场热点，揭露不为人知的真相。你需要的不是空泛的&quot;理财&quot;理论，而是落地可行的投资+投机双重机会。帮你打破固有的思维枷锁，从内在重塑你的财富观。 </p></div>", 2))
      ]),
      _createVNode(SuccessModal, {
        show: showSuccessModal.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showSuccessModal.value = false))
      }, null, 8, ["show"])
    ])
  ]))
}
}

})